import { Injectable } from '@angular/core';

/**
 * Сервис для централизованного контроля несохранённых изменений.
 * Компонент с потенциально несохранёнными данными регистрирует обработчик,
 * который guard вызывает при попытке покинуть маршрут.
 */
@Injectable({ providedIn: 'root' })
export class UnsavedChangesService {
  private handler: (() => Promise<boolean> | boolean) | null = null;

  register(handler: () => Promise<boolean> | boolean): void {
    this.handler = handler;
  }

  unregister(handler: () => Promise<boolean> | boolean): void {
    if (this.handler === handler) {
      this.handler = null;
    }
  }

  canLeave(): Promise<boolean> | boolean {
    if (!this.handler) {
      return true;
    }
    return this.handler();
  }
}
